import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Utils from "~/helpers/Utils";
import SchedulingFilter from "~/components/common/schedulingReport/SchedulingFilter";
import reportingAction from "~/actions/reportingAction";
import distanceReportAction from "~/actions/reporting/distanceReportAction";
import "~/components/reporting/Reporting.scss";

const DistanceFilterScheduling = (props) => {
    const dispatch = useDispatch();

    const { edition } = useSelector((state) => state.reporting.scheduling);

    const onFormRefUpdate = useCallback(
        (_scheduledForm) => {
            dispatch(distanceReportAction.updateScheduleForm(_scheduledForm.current));
        },
        [dispatch]
    );

    return (
        <SchedulingFilter
            edition={edition}
            onFormRefUpdate={onFormRefUpdate}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                dispatch(
                    reportingAction.saveDistanceReportScheduling(
                        {
                            Id: values.Id,
                            PeriodicidadeDia: values.PeriodicidadeDia,
                            Formato: values.Formato,
                            Email: values.Email,
                            DataInicio: moment(values.DataInicio).format("DD/MM/YYYY"),
                            ObjetoRastreavelId: parseInt(values.ObjetoRastreavel.id),
                        },
                        (error, res) => {
                            setSubmitting(false);

                            if (error) {
                                Utils.showAllErrors(error);
                                return;
                            }

                            resetForm();

                            dispatch(reportingAction.getDistanceReportScheduling({}));
                            dispatch(reportingAction.getDistanceReportSent({}));
                            dispatch(reportingAction.finishEditionDistanceReportScheduling());
                        }
                    )
                );
            }}
        />
    );
};

export default DistanceFilterScheduling;
